import { cmApi } from "@/api/cm-api"

const getGreeting = function () {
  var hour = new Date().getHours();
  if (hour < 6) return "凌晨好";
  if (hour < 9) return "早上好";
  if (hour < 12) return "上午好";
  if (hour < 14) return "中午好";
  if (hour < 18) return "下午好";
  if (hour < 24) return "晚上好";
  return "您好";
}

const processValue = (str) => {

  const data = JSON.parse(str)
  for (const key in data) {
    const v = data[key]
    if (typeof v !== 'string') {
      continue;
    }
    const value = v.trim()
    if (value.indexOf('{') === 0 || value.indexOf('[') === 0) {
      data[key] = JSON.parse(value)
      continue;
    }
    data[key] =  value.replace(/\{\{greeting\}\}/g, getGreeting())
  }
  return data
}

const projectPath = `${process.env.VUE_APP_PUBLIC_PATH}assets/project/${process.env.VUE_APP_PAGE_MODE}`

const state = {
  configLoaded: false,
  pageId: null,
  pageCode: null,
  sysConfig: {
    ApiUrl: window.sysConfig.ApiUrl,
    ApiToken: window.sysConfig.ApiToken,
    displayCartoon: window.sysConfig.displayCartoon,
    reasoningModel: window.sysConfig.reasoningModel,
    useConversationId: window.sysConfig.useConversationId,
    WelcomeText: window.sysConfig.WelcomeText,
    WelcomeTitle: window.sysConfig.WelcomeTitle,
    VoiceConfig: window.sysConfig.VoiceConfig,
    PageTitle: window.sysConfig.PageTitle,
    LogoName: window.sysConfig.LogoName,
    LogoImgUrl: window.sysConfig.LogoImgUrl,
    inputTips: window.sysConfig.inputTips,
    inputTipsList: window.sysConfig.inputTipsList,
    enableInputTipsList: window.sysConfig.enableInputTipsList,
    hotList: window.sysConfig.hotList,
    ttsWsUrl: window.sysConfig.ttsWebSocketUrl,
    enableTts: window.sysConfig.enableTts,
    enableAvatar: window.sysConfig.enableAvatar,
    districtFlag: window.sysConfig.districtFlag,
    baseDistrict: window.sysConfig.baseDistrict,
    aiName: window.sysConfig.aiName,
    xfszrAppId: window.sysConfig.xfszrAppId,
    xfszrApiKey: window.sysConfig.xfszrApiKey,
    xfszrApiSecret: window.sysConfig.xfszrApiSecret,
    projectPath,
    bgUrl: `${projectPath}/image/bg.png`,
    chatBgUrl: `${projectPath}/image/chat-bg.png`,
    robotUrl: `${projectPath}/image/robot.png`,
    robotHeadUrl: `${projectPath}/image/robothead.png`,
    userAvatarUrl: `${projectPath}/image/userAvatar.png`,
    messageStreamDelay: window.sysConfig.messageStreamDelay,
    enableMessageStreamDelay: window.sysConfig.enableMessageStreamDelay,
    showAccessibility: window.sysConfig.showAccessibility,
    AiTip: window.sysConfig.AiTip,
  }
}
const mutations = {
  setConfigLoaded(state, value) {
    state.configLoaded = value
  },
  setPageId(state, value) {
    state.pageId = value
  },
  setPageCode(state, value) {
    state.pageCode = value
  },
  mergeSysConfig(state, value) {
    state.sysConfig = Object.assign(state.sysConfig, value)
  },
}
const actions = {
  loadConfig({ commit }, { pageId, pageCode }) {
    if (pageId) {
      commit('setPageId', pageId)
    }
    if (pageCode) {
      commit('setPageCode', pageCode)
    }
    cmApi.getPublicConfig({ pageId, pageCode }).then((res) => {
      const data = processValue(res.data)
      commit('mergeSysConfig', data)
    }).finally(() => {
      commit('setConfigLoaded', true)
    })
  }
}
const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
